
const optimaModule = require('./optima');
const mdmModule = require('./mdm');
const indentManagementModule = require('./indent-management');
const erpModule = require('./erp');
const notificationsModule = require('./notifications');
const paymentsmodule = require('./payments');
const podModule = require('./pod');

const NimbusModules = {
  mdm: mdmModule,
  optima: optimaModule,
  indentManagement: indentManagementModule,
  erp: erpModule,
  payments: paymentsmodule,
  pod: podModule,
  notifications: notificationsModule,
};

const configNameMap = Object.keys(NimbusModules).reduce((acc, module) => {
  if (!acc[module]) {
    acc[module] = {};
  }
  Object.keys(NimbusModules[module].sections).forEach((section) => {
    Object.keys(NimbusModules[module].sections[section].configurations).forEach((config) => {
      acc[module][NimbusModules[module].sections[section].configurations[config].documentKey] = {
        section,
        config,
      };
    });
  });

  return acc;
}, {});

// console.log(configNameMap);

const documentKeyToConfig = (module, documentKey) => configNameMap[module][documentKey];

module.exports = {
  NimbusModules,
  documentKeyToConfig,
};
